import React, { useState } from 'react';
import { apiService } from '../services/api';
import { authService } from '../services/auth';
import './Login.css';

interface LoginProps {
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await apiService.login({ username, password });
      
      // Store the token and user info
      authService.setToken(result.access_token);
      authService.setUser({ username });
      
      // Call the success callback
      onLoginSuccess();
    } catch (err: any) {
      console.error('Login error:', err);
      if (err.response?.status === 401) {
        setError('Ungültiger Benutzername oder Passwort');
      } else if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/logo_berlin_m_srgb.svg" alt="Logo" className="login-logo" />
          <h1>GSTU Needle</h1>
          <p>Intelligente Unterstützung bei der Verarbeitung neuer Anforderungen für Handbücher.</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Benutzername:</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="form-input"
              placeholder="Benutzername eingeben"
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Passwort:</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-input"
              placeholder="Passwort eingeben"
              disabled={loading}
            />
          </div>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          <button 
            type="submit" 
            disabled={loading}
            className={`login-button ${loading ? 'loading' : ''}`}
          >
            {loading ? 'Anmelden...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
